import { TextTruncate } from '@coursera/coursera-ui';

import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/program-home/appEnv';

// Opt-into [Intersection|Resize|Mutation]Observer for <TextTruncate />.
if (TextTruncate.defaultProps) {
  TextTruncate.defaultProps.shouldUseObservers = true;
}

// Apply any teach specific styles to body
const bodyEl = document.getElementsByTagName('body')[0];
// @ts-expect-error TS18048 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
bodyEl.className += ' c-partner-home';

export default appStarterFactory(appEnv);

// force-build-counter: 1
